import React from 'react'
import Footer from '../Footer'
import RogerFive from '../RogerFive'

function Roger5() {
    window.scrollTo(0,0);
    return (
        <div>
            <RogerFive/>
            <Footer/>
        </div>
    )
}

export default Roger5
